import { renderToString } from 'react-dom/server';
import { CustomHighchartsTooltip, TooltipHeader, TooltipBody, TooltipBodyListContainer, TooltipBodyLabel, TooltipBodyValue, TooltipSeriesSymbol } from '../../../../highcharts/options/customTooltipStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const renderVennTooltip = point => {
  const isOverlap = point.sets && point.sets.length > 1;
  return renderToString( /*#__PURE__*/_jsxs(CustomHighchartsTooltip, {
    children: [/*#__PURE__*/_jsx(TooltipHeader, {
      children: "Details"
    }), /*#__PURE__*/_jsx(TooltipBody, {
      children: isOverlap ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(TooltipBodyListContainer, {
          children: [/*#__PURE__*/_jsx(TooltipSeriesSymbol, {
            color: '#8C8787'
          }), /*#__PURE__*/_jsx(TooltipBodyLabel, {
            children: `Segment Overlap (${point.sets.length} sets):`
          }), /*#__PURE__*/_jsx(TooltipBodyValue, {
            children: String(point.value)
          })]
        }), point.series && point.series.data && point.series.data.map(dataPoint => {
          if (dataPoint.sets && dataPoint.sets.length === 1 && point.sets.includes(dataPoint.sets[0])) {
            return /*#__PURE__*/_jsxs(TooltipBodyListContainer, {
              children: [/*#__PURE__*/_jsx(TooltipSeriesSymbol, {
                color: dataPoint.color
              }), /*#__PURE__*/_jsx(TooltipBodyLabel, {
                children: `${dataPoint.name}:`
              }), /*#__PURE__*/_jsx(TooltipBodyValue, {
                children: String(dataPoint.value)
              })]
            }, dataPoint.sets[0]);
          }
          return null;
        }).filter(Boolean)]
      }) : /*#__PURE__*/_jsxs(TooltipBodyListContainer, {
        children: [/*#__PURE__*/_jsx(TooltipSeriesSymbol, {
          color: point.color
        }), /*#__PURE__*/_jsx(TooltipBodyLabel, {
          children: `${point.name}:`
        }), /*#__PURE__*/_jsx(TooltipBodyValue, {
          children: String(point.value)
        })]
      })
    })]
  }));
};
export const getVennTooltipFormatter = () => {
  return function formatter() {
    const {
      point
    } = this;
    return renderVennTooltip(point);
  };
};